import React, { Suspense } from 'react'

import StyledAdminWrapper from './StyledAdminWrapper'
import AdminConfigsEntry from 'components_v2/Admin/AdminConfigs/AdminConfigsEntry'

const AdminConfigsWrapper = () => (
  <StyledAdminWrapper>
    <Suspense fallback=''>
      <AdminConfigsEntry />
    </Suspense>
  </StyledAdminWrapper>
)

export default AdminConfigsWrapper
